import React, { useState } from 'react'
import { DI } from 'modules'
import { Modal } from 'components/modal'
import Form from 'common/components/form/new-form'
import { TextInput } from 'components/form/text-input'

const ModalOTP = props => {
  const [chars, setChars] = useState('')
  const [error, setError] = useState(false)

  const { strings } = props.common

  const charsCounter = event => {
    const charCount = event.target.value
    setChars(charCount)
  }

  const onReset = () => {
    setChars('')
    props.close()
  }

  const onSubmit = (ev, form) => {
    props.actions.user
      .verifyOTP(form.confirmation_token)
      .then(() => {
        props.confirm(form.confirmation_token)
      })
      .catch(() => {
        setError(true)
      })
  }

  return (
    <Modal>
      <Form onReset={onReset} onSubmit={onSubmit}>
        <div className="popup-with-ico">
          <span className="popup__title">
            {strings['header.profile.otp.title']}
          </span>
          <div className="sign-in-text sign-in-text--pre">
            <p>{strings['header.profile.otp.description']}</p>
          </div>
          <div className="sign-in-text sign-in-text--pre">
            <p>{strings['header.profile.otp.description_2']}</p>
          </div>
          <div className="popup-field">
            <TextInput
              isRequired
              name="confirmation_token"
              onChange={charsCounter}
              placeholder={strings['header.profile.otp.placeholder']}
              value={chars}
            />
            {error && (
              <div className="error">{strings['header.profile.otp.error']}</div>
            )}
          </div>

          <div className="popup-buttons popup-buttons--ico">
            <div className="popup-button">
              <button className="button" type="submit">
                {strings['header.profile.otp.btn']}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default DI(['user'])(ModalOTP)
